module.exports = __webpack_public_path__ + "static/img/img_form_1@2x_zh_cn.0d02c426.png";